import { abyssColors } from '@/theme/colors';

export const labelStyles = {
  '& .MuiInputLabel-root': {
    color: abyssColors.primary[300],
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: abyssColors.primary[300],
  },
};
